import { WEBSITE_URL } from '../constants/env';
export default class WebsiteDataShare {
    constructor() {
        this.isLoaded = false;
        this.iframe = document.createElement('iframe');
        this.iframe.setAttribute('src', WEBSITE_URL);
        this.iframe.style.display = 'none';
        if (document.body) {
            document.body.appendChild(this.iframe);
        }
    }
    storeToken(token) {
        if (this.isLoaded) {
            return this.storeData(token);
        }
        this.iframe.onload = () => {
            this.isLoaded = true;
            this.storeData(token);
        };
    }
    storeData(data) {
        this.iframe.contentWindow?.postMessage(data, WEBSITE_URL);
    }
}
